import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import "dayjs/locale/ru"
import "dayjs/locale/uz-latn"
import type {AdminLanguage} from "./language"

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale("ru")

export const APP_TIME_ZONE = "Asia/Tashkent"

export const setDayjsLanguage = (language: AdminLanguage) => {
    dayjs.locale(language === "uz" ? "uz-latn" : "ru")
}

export default dayjs
